import { handleTimeseriesData} from './handlers/timeseriesPlot.js';
import { handleObjectDisplay } from './handlers/default.js';

export { responseHandlerRegistry };

/**
 * Registry object that maps response types to their corresponding handler functions.
 * @memberof vef.data.dasf
 */
const responseHandlerRegistry = {
    "timeseries": handleTimeseriesData,
    "default": handleObjectDisplay,
};
